import { CriterioCustom } from './criterio-custom';
import { MetadataExt, MetadataSearchCriteria } from './metadati/metadata';

export class CriteriUtente {
  searchText: string;      // testo libero - full text sui documenti
  soloContropartePrimaria: boolean;    // cerca solo controparte primaria
  posizionePratica: string;            // testo libero che matcha sulla posizione pratica
  definita: boolean;                   // a front-end devono comparire 3 valori: definite / pendenti / entrambe
  criteriCustom: { [key: string]: CriterioCustom; };
  metadataList:MetadataSearchCriteria[];
  constructor() {
    this.criteriCustom = {};
  };
}

